import { BottomSheetTabsListItemProps } from '@/components/molecules/BottomSheet/BottomSheetTabs/BottomSheetTabsList';
import { GetQnaCategoryGroupQuery } from '@/types/bff/gql-schema';
import { QnaCategoryGroup } from '@/types/qna';
import { useGetQnaCategoryGroupQuery } from './mobile/qna.gql.impl';

const parseQnaCategoryGroup = (data: GetQnaCategoryGroupQuery): QnaCategoryGroup => {
  const { questionCategoryGroups: categoryGroups } = data;

  const parsedCategories = () => {
    return categoryGroups.map((questionCategory) => {
      return {
        key: questionCategory.key,
        name: questionCategory.name,
        categories: questionCategory.questionCategories.map((category) => {
          return {
            ...category,
            key: questionCategory.key,
            title: category.name,
            content: category.description,
            iconImageUrl: category.iconImageUrl,
            value: category.questionCategoryId,
            checked: false,
          };
        }),
      };
    });
  };

  return {
    tabs: categoryGroups.map((category) => {
      const { key, name } = category;
      return {
        key,
        label: name,
        value: key,
      };
    }),
    tabsList: parsedCategories(),
    categories: parsedCategories().reduce(
      (acc, cur) => {
        return acc.concat(cur.categories);
      },
      [] as Array<BottomSheetTabsListItemProps>
    ),
  };
};

const useGetQnaCategoryGroup = () => {
  const { data: categoryGroup } = useGetQnaCategoryGroupQuery(
    {},
    {
      select: parseQnaCategoryGroup,
    }
  );

  return { categoryGroup };
};

export default useGetQnaCategoryGroup;
